import { Dropzone, Select, DateInput } from '@ui/src';
import { ApplicationDocumentType } from '../../../hoc/new-application/types';
import UploadedFile from './uploaded-file';
import { CorporateApplicationCreateDocumentTypes } from '../types';

import cn from '../new-application.module.css';

const CreateApplicationDocument = ({
  dropZoneInputRef,
  uploadInputRef,
  onUpload,
  onSelect,
  fileUploadInProgress,
  onDelete,
  documents,
  selectedGroup,
  uploadedFilesErrors,
  setExpirationDate,
  expirationDate,
  allowedDocumentsCategories,
  setUploadedFiles,
  documentGroupError,
  attachedDocumentsErrors,
  attachedFiles,
  uploadedDocumentsErrors,
}: CorporateApplicationCreateDocumentTypes) => (
  <div className={cn.documentCreate}>
    <div className={cn.fileInputWrapper}>
      <div className={cn.inputTitle}>File</div>
      <label htmlFor="upload-input" className={cn.fileInputLabel}>
        <input
          type="file"
          id="upload-file"
          className={cn.fileInput}
          onChange={(e) => onUpload(e.target.files as FileList)}
          ref={uploadInputRef}
          multiple
        />
        <div className={cn.fileInputVisual}>Select document on your PC</div>
      </label>
    </div>
    <Dropzone
      onUpload={onUpload}
      fileUploadInProgress={fileUploadInProgress}
      inputRef={dropZoneInputRef}
      dropzoneText="or drop file here"
      dropzoneClassName={cn.documentDropZone}
      dropzoneTextClassName={cn.documentDropZoneText}
    />
    {documents &&
      documents.length > 0 &&
      documents.map((item) => (
        <UploadedFile
          key={item.id}
          item={item}
          items={documents}
          onDelete={onDelete}
          setUploadedFiles={setUploadedFiles}
          error={
            attachedDocumentsErrors ? attachedDocumentsErrors[item.id] : ''
          }
          attachedFiles={attachedFiles}
        />
      ))}
    {uploadedDocumentsErrors && uploadedDocumentsErrors?.length > 0 && (
      <ul className={cn.uploadedDocumentsErrors}>
        {uploadedDocumentsErrors?.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${item.name}-${index}`}>
            - The document <strong>{item.name}</strong> was not uploaded.
            <br />
            <span>
              <strong>Reason:</strong> {item.error}
            </span>
          </li>
        ))}
      </ul>
    )}
    {uploadedFilesErrors && uploadedFilesErrors.length > 0 && (
      <ul className={cn.uploadedFilesErrors}>
        {uploadedFilesErrors.map((item) => (
          <li key={item}>{`- ${item}`}</li>
        ))}
      </ul>
    )}
    <div className={cn.selectWrapper}>
      <div className={cn.inputTitle}>Group</div>
      <Select
        list={allowedDocumentsCategories
          ?.filter((item) => !item.id.includes('identification'))
          ?.map((item) => ({
            name: item.name,
            value: item.id,
          }))}
        selectWrapperClassName={`${cn.documentGroupSelect} ${
          documentGroupError ? cn.documentGroupSelectError : ''
        }`}
        placeholder="Select document group"
        name="documentGroup"
        value={selectedGroup}
        error={documentGroupError}
        onChange={(e) => onSelect(e.target.value as ApplicationDocumentType)}
      />
    </div>
    <div className={cn.selectWrapper}>
      <div className={cn.inputTitle}>Expiration Date</div>
      <DateInput
        value={expirationDate ? expirationDate?.toISOString() : ''}
        onChange={(date) => setExpirationDate(date)}
        placeholder="Select Expiration Date"
        className={cn.expirationDate}
        withoutCustomSelector
        withValueReset
        fullWidth
      />
    </div>
  </div>
);

export default CreateApplicationDocument;
